const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');
const trimSlashes = (value: string): string => value.replace(/^\/+|\/+$/g, '');

const API_ENDPOINT = trimTrailingSlash(process.env.REACT_APP_API_ENDPOINT || '');
const LEGACY_API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || '/api';
const V2_API_BASE_PATH = process.env.REACT_APP_API_V2_BASE_PATH || '/api/v2';

export type ApiVersion = 'legacy' | 'v2';

const apiBasePaths: Record<ApiVersion, string> = {
  legacy: LEGACY_API_BASE_PATH,
  v2: V2_API_BASE_PATH,
};

export const getApiBaseUrl = (version: ApiVersion = 'legacy'): string => {
  const basePath = trimSlashes(apiBasePaths[version]);
  return basePath ? `${API_ENDPOINT}/${basePath}` : API_ENDPOINT;
};

export const buildApiUrl = (path: string, version: ApiVersion = 'legacy'): string => {
  const normalizedPath = trimSlashes(path);
  const baseUrl = getApiBaseUrl(version);

  return normalizedPath ? `${baseUrl}/${normalizedPath}` : baseUrl;
};
